var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 1.66797C5.40829 1.66797 1.66663 5.40964 1.66663 10.0013C1.66663 14.593 5.40829 18.3346 9.99996 18.3346C14.5916 18.3346 18.3333 14.593 18.3333 10.0013C18.3333 5.40964 14.5916 1.66797 9.99996 1.66797ZM12.8 11.918C13.0416 12.1596 13.0416 12.5596 12.8 12.8013C12.675 12.9263 12.5166 12.9846 12.3583 12.9846C12.2 12.9846 12.0416 12.9263 11.9166 12.8013L9.99996 10.8846L8.08329 12.8013C7.95829 12.9263 7.79996 12.9846 7.64163 12.9846C7.48329 12.9846 7.32496 12.9263 7.19996 12.8013C6.95829 12.5596 6.95829 12.1596 7.19996 11.918L9.11663 10.0013L7.19996 8.08464C6.95829 7.84297 6.95829 7.44297 7.19996 7.2013C7.44163 6.95964 7.84163 6.95964 8.08329 7.2013L9.99996 9.11797L11.9166 7.2013C12.1583 6.95964 12.5583 6.95964 12.8 7.2013C13.0416 7.44297 13.0416 7.84297 12.8 8.08464L10.8833 10.0013L12.8 11.918Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.72ce1cb88e8456f8dec77ea93c1076e0.svg";
export { ForwardRef as ReactComponent };